import { css } from "styled-components";

interface ListHoursItemProps {
  selected: boolean;
}

const InputHourListHoursItem = css<ListHoursItemProps>`
  cursor: pointer;
  user-select: none;
  ${({ selected }) => selected && `
    background-color: #BBEDF8;
    color: #fff;
    font-weight: 600 !important;
  `}
`;


export default InputHourListHoursItem;
